import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Empty, Message, Table } from "@arco-design/web-react";
import { IconDelete, IconEdit, IconPlus } from "@arco-design/web-react/icon";
import moment from "moment";

import { FetchApi, DeleteApi } from "../Api/AuthenticatedApi";
import SimpleBreadcrumbs from "../Components/Breadcrumbs/SimpleBreadcrumbs";
import Content from "../Layout/Content";
import LoadingState from "../Layout/LoadingState";
import SummaryCard from "../Layout/SummaryCard";

export default function Templates() {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (!refresh) return;
    FetchApi(getAccessTokenSilently, "/api/email-templates/",
      (data) => { setTemplates(data || []); setLoading(false); setRefresh(false); },
      () => navigate("/login"),
      () => { setLoading(false); setRefresh(false); Message.error("Failed to load templates"); });
  }, [getAccessTokenSilently, navigate, refresh]);

  const handleDelete = (id) => {
    DeleteApi(getAccessTokenSilently, "/api/email-templates/" + id,
      () => { Message.success("Template deleted"); setRefresh(true); },
      () => navigate("/login"),
      () => Message.error("Failed to delete template"),
      {});
  };

  const columns = [
    { title: "Name", dataIndex: "name", render: (n) => <strong>{n}</strong> },
    {
      title: "Subject",
      dataIndex: "mail_subject_template",
      render: (s) => s || <span style={{ color: "var(--color-text-3)" }}>—</span>,
    },
    {
      title: "Created",
      dataIndex: "created_date",
      render: (d) => (d ? moment(d).format("MMM D, YYYY") : ""),
    },
    {
      title: "",
      render: (_, t) => (
        <>
          <Button size="small" shape="circle" type="text" icon={<IconEdit />} onClick={() => navigate("/templates/" + t.id)} />
          <Button size="small" shape="circle" type="text" status="danger" icon={<IconDelete />} onClick={() => handleDelete(t.id)} />
        </>
      ),
    },
  ];

  if (loading) {
    return <LoadingState />;
  }

  return (
    <Content>
      <SimpleBreadcrumbs elements={[{ name: "Templates" }]} />
      <SummaryCard
        title="Email templates"
        subTitle="Reusable email designs you can start a new email from"
        titleElement={
          <Button size="small" type="primary" icon={<IconPlus />} onClick={() => navigate("/templates/new")}>
            New template
          </Button>
        }
      >
        <Table
          size="small"
          columns={columns}
          data={templates}
          rowKey="id"
          pagination={false}
          border={false}
          noDataElement={
            <Empty description='No templates yet — click "New template" to create one (or "Save as template" from any email editor).' />
          }
        />
      </SummaryCard>
    </Content>
  );
}
